import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-insider-null",
  // imports: [],
  templateUrl: "./insider-null.component.html",
  styleUrl: "./insider-null.component.css",
  standalone: false,
})
export class InsiderNullComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
